import Controller from 'cio/pods/broadcasts/newsletter/setup/controller';
export default Controller;
